import { render, staticRenderFns } from "./AddNote.vue?vue&type=template&id=2568b921&scoped=true&"
import script from "./AddNote.vue?vue&type=script&lang=js&"
export * from "./AddNote.vue?vue&type=script&lang=js&"
import style0 from "./AddNote.vue?vue&type=style&index=0&id=2568b921&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2568b921",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2568b921')) {
      api.createRecord('2568b921', component.options)
    } else {
      api.reload('2568b921', component.options)
    }
    module.hot.accept("./AddNote.vue?vue&type=template&id=2568b921&scoped=true&", function () {
      api.rerender('2568b921', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/modules/notes/components/AddNote.vue"
export default component.exports